import { sip_trunks } from './sip-trunks';
import { stats } from './stats';

export const verification = {
  namespaced: true,
  modules: {
    'sip-trunks': sip_trunks,
    stats
  }
};
